module.exports = __webpack_public_path__ + "static/media/hamburger.519a2e1b.svg";